import { render, staticRenderFns } from "./mutfak.vue?vue&type=template&id=60453dd4&scoped=true&"
import script from "./mutfak.vue?vue&type=script&lang=js&"
export * from "./mutfak.vue?vue&type=script&lang=js&"
import style0 from "./mutfak.vue?vue&type=style&index=0&id=60453dd4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60453dd4",
  null
  
)

export default component.exports